export function revealRenderer() {
  document.documentElement.setAttribute("data-renderer-state", "ready");
}

export function showRendererStartupError() {
  if (typeof document === "undefined") return;
  const showError = () => {
    if (!document.getElementById("rendererStartupError")) {
      const message = document.createElement("div");
      message.id = "rendererStartupError";
      message.setAttribute("role", "alert");
      message.textContent =
        "FlowTruss Analyze could not start. Please close the app and try again.";
      document.body.appendChild(message);
    }
    document.documentElement.setAttribute("data-renderer-state", "failed");
  };
  if (document.body) showError();
  else document.addEventListener("DOMContentLoaded", showError, { once: true });
}
